const initialState = {
  selected: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_SELECTED_CURRENCY":
      return { ...state, selected: payload };

    default:
      return state;
  }
};
